<template>
  <div class="registro-page">
    <div class="contenido-registro">

      <b-img class="logo-registro" :src="logo" />

      <b-card class="card-registro">
        <AutoRegistroInstitucion
          @volver="irAlLogin"
          @registroExitoso="onRegistroExitoso"
          @registroError="onRegistroError"
        />
      </b-card>

    </div>

    <!-- Versión -->
    <div class="login-version">
      <small>Oxígeno HelpHarma v{{ appVersion }}</small>
    </div>

    <!-- Modal de éxito -->
    <b-modal
      v-model="modalExito"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="text-center py-4">
        <b-icon icon="check-circle-fill" font-scale="4" variant="success" class="mb-3" />
        <h5 class="poppins-semi-bold-mine-shaft-20px">¡Registro exitoso!</h5>
        <p class="text-muted mb-4">
          Tu cuenta ha sido creada. Revisa tu correo electrónico para confirmar tu acceso.
        </p>
        <b-button class="boton-ingreso px-5" @click="irAlLogin">Ir al inicio de sesión</b-button>
      </div>
    </b-modal>

    <!-- Modal de error -->
    <b-modal
      v-model="modalError"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="text-center py-4">
        <b-icon icon="x-circle-fill" font-scale="4" variant="danger" class="mb-3" />
        <h5 class="poppins-semi-bold-mine-shaft-20px">Error en el registro</h5>
        <p class="text-muted mb-4">
          {{ mensajeError }}
        </p>
        <b-button variant="danger" class="px-5" @click="cerrarModalError">Cerrar</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import AutoRegistroInstitucion from "../components/AutoRegistroInstitucion.vue";

export default {
  name: "RegistroInstitucion",

  components: { AutoRegistroInstitucion },

  props: [
    "logo",
    "cielumProps",
  ],

  data() {
    return {
      modalExito: false,
      modalError: false,
      mensajeError: '',
      appVersion: process.env.VUE_APP_VERSION || process.env.npm_package_version || '1.0.0',
    };
  },

  methods: {
    irAlLogin() {
      this.$router.push('/login');
    },
    onRegistroExitoso() {
      this.modalExito = true;
    },
    onRegistroError(error) {
      // Extraer mensaje de error del objeto o string
      if (typeof error === 'string') {
        this.mensajeError = error;
      } else if (error && error.message) {
        this.mensajeError = error.message;
      } else if (error && error.response && error.response.data) {
        this.mensajeError = error.response.data.message || error.response.data.error || 'Ha ocurrido un error en el registro. Por favor, verifica los datos e intenta nuevamente.';
      } else {
        this.mensajeError = 'Ha ocurrido un error en el registro. Por favor, verifica los datos e intenta nuevamente.';
      }
      this.modalError = true;
    },
    cerrarModalError() {
      this.modalError = false;
      this.mensajeError = '';
    },
  },
};
</script>

<style scoped>
.registro-page {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  background-color: var(--blue-violet);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2.5rem 1rem 3rem;
}

.contenido-registro {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.logo-registro {
  width: 30%;
  max-width: 160px;
  margin-bottom: 1.5rem;
}

.card-registro {
  background-color: var(--zircon, #f4f7ff) !important;
  border-radius: 12px !important;
  border-color: transparent !important;
  width: 100%;
  max-width: 560px;
  padding: 0.5rem;
}

/* Versión */
.login-version {
  position: fixed;
  bottom: 10px;
  right: 15px;
  z-index: 1000;
}
.login-version small {
  color: rgba(255, 255, 255, 0.6);
  font-size: 11px;
}

/* Botón mismo estilo que login */
.boton-ingreso {
  background-color: var(--blue-violet, #5e35b1) !important;
  border-radius: 10px !important;
  border-color: transparent !important;
  height: 48px;
  font-weight: 600;
  color: #fff !important;
}
.boton-ingreso:hover {
  background: var(--hover, #4527a0) !important;
}
</style>
